import * as React from 'react';
import { theme } from '../../../theme';

interface Props {
  color?: string;
}

export const FailedIconSmall: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0818 10.5L6.24219 6.5M6.2426 10.5L10.0822 6.5"
      stroke={color}
      strokeWidth="1.44"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5617 8.50004C14.5617 4.81814 11.6963 1.83337 8.16172 1.83337C4.62709 1.83337 1.76172 4.81814 1.76172 8.50004C1.76172 12.1819 4.62709 15.1667 8.16172 15.1667C11.6963 15.1667 14.5617 12.1819 14.5617 8.50004Z"
      stroke={color}
      strokeWidth="1.44"
    />
  </svg>
);
